import request from '@/utils/request'

export function epmsa360Detail(param) {
  return request({
    url: `/outsoucingBlockControl/epmsa360/epmsa360Detail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param
  })
}

export function epmsa360Summary(param) {
  return request({
    url: `/outsoucingBlockControl/epmsa360/epmsa360Summary`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param
  })
}